import { format } from 'date-fns';
import firebase from './firebase';

const db = firebase.firestore();
const increment = firebase.firestore.FieldValue.increment;

const extractCollectionName = (ref) => {
  const path = ref?.path || '';
  const segments = path.split('/').filter(Boolean);
  if (segments.length === 0) return '';
  return segments.length % 2 === 0 ? segments[segments.length - 2] : segments[segments.length - 1];
};

const getPage = () => {
  const path = window.location.pathname || '/';
  // /admin/tenants/LGP123 => /admin/tenants （動的IDセグメントだけ除去）
  const segments = path.split('/').filter(Boolean);
  const staticSegments = segments.filter(_ => !/^[A-Z]{2,}\d+/.test(_));
  return '/' + staticSegments.join('/');
};

export const countRead = (ref, docCount) => {
  const collection = extractCollectionName(ref);
  if (!collection) return;
  const page = getPage();
  const today = format(new Date(), 'yyyy-MM-dd');
  db.collection('stats').doc(`firestoreReads__${today}`).set({
    totalCount: increment(docCount),
    collections: { [collection]: increment(docCount) },
    pages: { [page]: { totalCount: increment(docCount), [collection]: increment(docCount) } },
  }, { merge: true });
};
